export { JargonHubFeature } from "./lib/feature-jargon-hub";
export { getStaticProps } from "./lib/get-static-props";
